import * as _ from 'lodash';

export const removeRedundancy = (array: any, fieldName?: string): any[] =>
  _.uniqBy(array, (c: any) => (fieldName ? c[fieldName] : c));
